import n from "./index807.js";
function f(t) {
  var e = t == null ? 0 : t.length;
  return e ? n(t) : [];
}
export {
  f as default
};
